import { gql } from '@apollo/client';

export const UPDATE_BOARDER_ABSENCES = gql`
  mutation UpdateBoarderAbsences($input: UpdateBoarderAbsencesInput!) {
    updateBoarderAbsences(input: $input) {
      boarderId
    }
  }
`;
